import { Box } from '@chakra-ui/react'

interface GapIProps {
  size?: number
}

export const Gap = ({ size = 4 }: GapIProps) => {
  return <Box mt={size} />
}
